

import { all, call, put, takeLatest } from 'redux-saga/effects'
import * as api from '../services/api'

const initialState = {
  monitoringCosts: [],
  newsSummaryCosts: [],
  collected: false,
}

export function reducer(state = initialState, action) {

  switch (action.type) {

    case 'aiCosts.collect':
      return {
        ...state,
      }

    case 'aiCosts.set': {
      return {
        ...state,
        monitoringCosts: action.monitoringCosts,
        newsSummaryCosts: action.newsSummaryCosts,
        collected: true,
      }
    }

    default: {
      return state
    }
  }
}

function* handleCollectAiCosts() {
  const { monitoringCosts, newsSummaryCosts } = yield call(api.monitoring.getAiCosts)
  yield put(actions.set({ monitoringCosts, newsSummaryCosts }))
}

//#region actions, selectors and sagas
export const actions = {
  collect: () => ({ type: 'aiCosts.collect' }),
  set: props => ({ type: 'aiCosts.set', ...props }),
}

export const selectors = {
  getMonitoringCosts: state => state.monitoringCosts,
  getNewsSummaryCosts: state => state.newsSummaryCosts,
  getCollected: state => state.collected,
}

export function* sagas() {
  yield all([
    takeLatest('aiCosts.collect', handleCollectAiCosts),
  ])
}
//#endregion
